const APOLLO_NETWORK_REQUESTS_EDIT = 'app/apollo/editNetworkRequest';

export {
  // eslint-disable-next-line import/prefer-default-export
  APOLLO_NETWORK_REQUESTS_EDIT,
};
